@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/shared/components/glass-house-brands/glass-house-brand-logo/glass-house-brand-logo.component.scss */
:host {
  display: contents;
}
:host .glass-house-brand-logo {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
:host .glass-house-brand-logo .brand-logo {
  max-height: 90%;
  max-width: 80%;
}
/*# sourceMappingURL=glass-house-brand-logo.component.css.map */
